
  import { composeConfigs, PreviewWeb, ClientApi } from '@storybook/preview-api';

  // generateAddonSetupCode
  import { createBrowserChannel } from '@storybook/channels';
  import { addons } from '@storybook/preview-api';

  const channel = createBrowserChannel({ page: 'preview' });
  addons.setChannel(channel);
  window.__STORYBOOK_ADDONS_CHANNEL__ = channel;

  const importers = {
      ...import("story:Li4vLi4vLi4vcGFja2FnZXMvKiovY2hyb21hdGljLyoqLyouc3Rvcmllcy5AKGpzfGpzeHx0c3x0c3gp"),
...import("story:Li4vLi4vLi4vcGFja2FnZXMvQHJlYWN0LXNwZWN0cnVtL3MyL2Nocm9tYXRpYy8qLnN0b3JpZXMuQChqc3xqc3h8bWpzfHRzfHRzeCk=")
    };

    async function importFn(path) {
      return importers[path]();
    }

  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/dist/entry-preview.mjs'),
import('../../../.chromatic/preview.js')])
    return composeConfigs(configs);
  }

  if (!window.__STORYBOOK_PREVIEW__) {
    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
  }

  module.hot.accept(() => {
    // importFn has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn });

    // getProjectAnnotations has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations });
  });
 